import { Suspense, lazy } from "react";
import { Navigate, useRoutes, useLocation } from "react-router-dom";
// layouts
import DashboardLayout from "../layouts/dashboard";
import ChecklistMaster from "../pages/master/checklist";
import ChecklistCategoryMaster from "../pages/master/checklist-category";
import DesignationMaster from "../pages/master/designation";
import DocumentTypeMaster from "../pages/master/document-type";
import IncidentCategoryMaster from "../pages/master/incident-category";

// guards
import GuestGuard from "../guards/GuestGuard";
import AuthGuard from "../guards/AuthGuard";
// import RoleBasedGuard from '../guards/RoleBasedGuard';
// config
import { PATH_AFTER_LOGIN } from "../config";
import { PATH_DASHBOARD } from "./paths";
// components
import LoadingScreen from "../components/LoadingScreen";

// ----------------------------------------------------------------------

export const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense
      fallback={<LoadingScreen isDashboard={pathname.includes("/dashboard")} />}
    >
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
      ],
    },
    // Dashboard Routes
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        {
          element: (
            <Navigate
              to={
                localStorage.getItem("userType") === "MANAGER" ||
                localStorage.getItem("userType") === "CLIENT"
                  ? PATH_DASHBOARD.reports.attendanceReport
                  : PATH_AFTER_LOGIN
              }
              replace
            />
          ),
          index: true,
        },
        { path: "app", element: <GeneralApp /> },
        {
          path: "master",
          children: [
            //User Master
            { path: "create-login", element: <UserMaster /> },
            //Company Master
            { path: "company", element: <CompanyMaster /> },
            //Staff Master
            { path: "staff", element: <StaffMaster /> },
            //Client Master
            { path: "client", element: <ClientMaster /> },
            //Client QR Code
            { path: "client-qr-code", element: <ClientQrCode /> },
            //Checklist Category Master
            { path: "checklist-category", element: <ChecklistCategoryMaster /> },
            //Checklist Master
            { path: "checklist", element: <ChecklistMaster /> },
            //Designation Master
            { path: "designation", element: <DesignationMaster /> },
            //Incident Category Master
            { path: "incident-category", element: <IncidentCategoryMaster /> },
            //Documents Master
            { path: "documents", element: <DocumentsMaster /> },
            //Document Type Master
            { path: "document-types", element: <DocumentTypeMaster /> },
          ],
        },
        {
          path: "reports",
          children: [
            { path: "attendance-report", element: <AttendanceReport /> },
            { path: "patrolling-report", element: <PatrollingReport /> },
            { path: "master-report", element: <MasterReport /> },
            { path: "live-tracking", element: <LiveTracking /> },
            { path: "live-tracking-history", element: <TrackingHistory /> },
          ],
        },
      ],
    },

    // Main Routes

    {
      path: "/",
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}

// AUTHENTICATION
const Login = Loadable(lazy(() => import("../pages/auth/Login")));

// DASHBOARD

// GENERAL
const GeneralApp = Loadable(
  lazy(() => import("../pages/dashboard/GeneralApp")),
);
// User Master
const UserMaster = Loadable(lazy(() => import("src/pages/master/user")));
// Company Master
const CompanyMaster = Loadable(lazy(() => import("src/pages/master/company")));
// Staff Master
const StaffMaster = Loadable(lazy(() => import("src/pages/master/staff")));
// Client Master
const ClientMaster = Loadable(lazy(() => import("src/pages/master/client")));
// Documents Master
const DocumentsMaster = Loadable(lazy(() => import("src/pages/master/documents")));
// Client QR Code
const ClientQrCode = Loadable(
  lazy(() => import("src/pages/master/client-qr-code")),
);
const AttendanceReport = Loadable(
  lazy(() => import("src/pages/reports/attendance")),
);
const PatrollingReport = Loadable(
  lazy(() => import("src/pages/reports/patrolling")),
);
const MasterReport = Loadable(
  lazy(() => import("src/pages/reports/master-reports")),
);
const LiveTracking = Loadable(
  lazy(() => import("src/pages/reports/tracking")),
);
const TrackingHistory = Loadable(
  lazy(() => import("src/pages/reports/tracking/History")),
);
